import { INSIGHTS_ACTIVITY_MAP_CHART_ACTIONS, INSIGHTS_ACTIVITY_MAP_FETCHER_ACTIONS } from "../../actions/insightsActivityMapActions";
import { ACTIVITY_MAP_VIEWS } from '../../constants/common';

let defaultState = {
    isLoading : true,
    apiError : null,
    isChartLoading : true,
    enableLeftArrow : false,
    enableRightArrow : false,
    activityMapControls : {
        view : ACTIVITY_MAP_VIEWS.HOURS_OF_OPERATION
    },
    data: null
};

const insightsActivityMapReducer = (state =  Object.assign({}, defaultState), action) => {
    switch (action.type){
        case INSIGHTS_ACTIVITY_MAP_CHART_ACTIONS.UPDATE_CONTROL:
            //let view = action.payload.view || state.activityMapControls.view;
            state = {
                ...state,
                activityMapControls: {
                    ...state.activityMapControls,
                    ...action.payload
                }
            }
            break;
        case INSIGHTS_ACTIVITY_MAP_FETCHER_ACTIONS.FETCH_ACTIVITY_MAP_DATA_SUCCESS:
            let activityMapData = action.payload.data;
            let enableLeftArrow = activityMapData.previousIntervalStart != null;
            let enableRightArrow = activityMapData.nextIntervalStart != null;
            state = {
                ...state,
                data: activityMapData,
                apiError: false,
                isChartLoading : false,
                isLoading: false,
                enableLeftArrow,
                enableRightArrow,
                activityMapControls: {
                    ...state.activityMapControls
                }
            }
            break;
        case INSIGHTS_ACTIVITY_MAP_FETCHER_ACTIONS.FETCH_ACTIVITY_MAP_DATA_FAILURE:
            state = {
                ...state,
                isChartLoading: false,
                isLoading: false,
                apiError: true
            }
            break;
        case INSIGHTS_ACTIVITY_MAP_FETCHER_ACTIONS.FETCHING_ACTIVITY_MAP_DATA:
            state = {
                ...state,
                isChartLoading : true
            };
            break;
        default:
            break;
    }

    return state;
}

export default insightsActivityMapReducer;
